import { render, staticRenderFns } from "./send-comment.vue?vue&type=template&id=c3246946"
var script = {}
import style0 from "./send-comment.vue?vue&type=style&index=0&id=c3246946&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports